import {
    server
} from "@/api";


export const admin = {
    agents: async (params) => {
        return await server().get('api/dashboard/admin/agents', { params })
    },

    followups: async (params) => {
        return await server().get('api/dashboard/admin/followups', { params })
    },

    overview: async (params) => {
        return await server().get('api/dashboard/admin/overview', { params })
    },
    
    dailyNewOrders: async (params) => {
        return await server().get('api/dashboard/admin/daily-new-orders', { params })
    },

    dailyConfirmedOrders: async (params) => {
        return await server().get('api/dashboard/admin/daily-confirmed-orders', { params })
    },

    dailyDeliveredOrders: async (params) => {
        return await server().get('api/dashboard/admin/daily-delivered-orders', { params })
    }
}


export const agent = {
    performance: async (params) => {
        return await server().get('api/dashboard/agent/performance', { params })
    },

    dailyDroppedOrders: async (params) => {
        return await server().get('api/dashboard/agent/daily-dropped-orders', { params })
    },

    dailyTreatedOrders: async (params) => {
        return await server().get('api/dashboard/agent/daily-treated-orders', { params })
    },

    dailyConfirmedOrders: async (params) => {
        return await server().get('api/dashboard/agent/daily-confirmed-orders', { params })
    },

    dailyDeliveredOrders: async (params) => {
        return await server().get('api/dashboard/agent/daily-delivered-orders', { params })
    },

    topProducts: async (params) => {
        return await server().get('api/dashboard/agent/top-products', { params })
    }

}

export const marketer = {
    overview: async (params) => {
        return await server().get('api/dashboard/marketer/overview', { params })
    },

    leadsPerDay: async (params) => {
        return await server().get('api/dashboard/marketer/daily-leads', { params })
    },

    spendPerDay: async (params) => {
        return await server().get('api/dashboard/marketer/daily-spend', { params })
    },

    costPerLead: async (params) => {
        return await server().get('api/dashboard/marketer/daily-cost-per-lead', { params })
    },

    usersRanking: async (params) => {
        return await server().get('api/dashboard/marketer/users-ranking', { params })
    }
}

export const followup = {
    performance: async (params) => {
        return await server().get('api/dashboard/followup/performance', { params })
    },

    dailyTreatedFollowups: async (params) => {
        return await server().get('api/dashboard/followup/daily-treated-followups', { params })
    },

    dailyReconfirmedFollowups: async (params) => {
        return await server().get('api/dashboard/followup/daily-reconfirmed-followups', { params })
    },

    dailyFollowupCalls: async (params) => {
        return await server().get('api/dashboard/followup/daily-followup-calls', { params })
    },

    dailyAssignedFollowups: async (params) => {
        return await server().get('api/dashboard/followup/daily-assigned-followups', { params })
    },

    topProducts: async (params) => {
        return await server().get('api/dashboard/followup/top-products', { params })
    },

    reconfirmation: async (params) => {
        return await server().get('api/dashboard/followup/reconfirmation', { params })
    },

    delivery: async (params) => {
        return await server().get('api/dashboard/followup/delivery', { params })
    }
}

export const followupManager = {
    performance: async (params) => {
        return await server().get('api/dashboard/followup-manager/performance', { params })
    },

    dailyTreatedFollowups: async (params) => {
        return await server().get('api/dashboard/followup-manager/daily-treated-followups', { params })
    },

    dailyReconfirmedFollowups: async (params) => {
        return await server().get('api/dashboard/followup-manager/daily-reconfirmed-followups', { params })
    },

    dailyFollowupCalls: async (params) => {
        return await server().get('api/dashboard/followup-manager/daily-followup-calls', { params })
    },

    dailyAssignedFollowups: async (params) => {
        return await server().get('api/dashboard/followup-manager/daily-assigned-followups', { params })
    },

    topProducts: async (params) => {
        return await server().get('api/dashboard/followup-manager/top-products', { params })
    },

    reconfirmation: async (params) => {
        return await server().get('api/dashboard/followup-manager/reconfirmation', { params })
    },

    delivery: async (params) => {
        return await server().get('api/dashboard/followup-manager/delivery', { params })
    }
}

export default {
    admin,
    agent,
    marketer,
    followup,
    followupManager
}